import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=0c95c6d7&scoped=true&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"
import style0 from "./contacts.vue?vue&type=style&index=0&id=0c95c6d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95c6d7",
  null
  
)

/* custom blocks */
import block0 from "./contacts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports